import { services } from "onearm";
import { GameStates } from "onearm";

import { SubGameState } from "./SubGameState";

export class Idle extends SubGameState {
    enter() {
        super.enter();

        this.bets = services.get("bets");

        this.addSignalHandler(this.hud.onPressMinus, this.onPressMinus.bind(this));
        this.addSignalHandler(this.hud.onPressPlus, this.onPressPlus.bind(this));
        this.addSignalHandler(this.hud.onPressInfo, this.onPressInfo.bind(this));
        this.addSignalHandler(this.hud.onPressAutoplay, this.handlePressAutoplay.bind(this));
        this.addSignalHandler(this.hud.onPressBuyBonus, this.onPressBuyBonus.bind(this));
        this.addSignalHandler(this.hud.onPressSettings, this.onPressSettings.bind(this));
        this.addSignalHandler(this.hud.onPressSpin, this.pressSpinHandler.bind(this));
        this.addSignalHandler(this.hud.onPressStop, this.handlePressStopAutoplay.bind(this));
        this.addSignalHandler(this.keyboard.onSpacePress, this.pressSpinHandler.bind(this));

        this.addSignalHandler(this.hud.onPressBetPlus, this.onPressBetPlus.bind(this));
        this.addSignalHandler(this.hud.onPressBetMinus, this.onPressBetMinus.bind(this));
        this.addSignalHandler(this.hud.onPressCoinValuePlus, this.onPressCoinValuePlus.bind(this));
        this.addSignalHandler(this.hud.onPressCoinValueMinus, this.onPressCoinValueMinus.bind(this));
        this.addSignalHandler(this.hud.onPressTotalBetPlus, this.onPressTotalBetPlus.bind(this));
        this.addSignalHandler(this.hud.onPressTotalBetMinus, this.onPressTotalBetMinus.bind(this));
        this.addSignalHandler(this.hud.onPressBetMax, this.onPressBetMax.bind(this));
        this.addSignalHandler(this.hud.onPressCloseBetSettings, this.onPressCloseBetSettings.bind(this));

        this.addSignalHandler(this.bets.onBetChanged, this.onBetChanged.bind(this));
        this.addSignalHandler(this.bets.onCoinValueChanged, this.onCoinValueChanged.bind(this));
        this.addSignalHandler(this.hud.onSpinSpeedChange, this.onSpinSpeedChange.bind(this));
        this.addSignalHandler(this.hud.onChangeDoubleChanceToggle, this.handleToggleDoubleChance.bind(this));

        if (this.autoplay.isActive()) {
            Promise.resolve().then(this.spin.bind(this));
        }

        this.hud.setSpinState();
        this.hud.setIdleState();
        this.updateBetSettingsUI();
    }

    updateBetSettingsUI() {
        this.hud.setBetValue(this.bets.bet);
        this.hud.setCoinValue(this.bets.coinValue);
        this.gameState.updateTotalBet(this.bets.totalBet);
    }

    handlePressStopAutoplay() {
        if (this.autoplay.isActive()) {
            this.autoplay.stop();
        }
    }

    pressSpinHandler() {
        this.spin();
    }

    onPressMinus() {
        this.bets.previousTotalBet();
        this.hud.showBetSettings();
    }

    onPressPlus() {
        this.bets.nextTotalBet();
        this.hud.showBetSettings();
    }

    onPressBetPlus() {
        this.bets.nextBetValue();
    }

    onPressBetMinus() {
        this.bets.previousBetValue();
    }

    onPressCoinValuePlus() {
        this.bets.nextCoinValue();
    }

    onPressCoinValueMinus() {
        this.bets.previousCoinValue();
    }

    onPressTotalBetPlus() {
        this.bets.nextTotalBet();
    }

    onPressTotalBetMinus() {
        this.bets.previousTotalBet();
    }

    onPressBetMax() {
        this.bets.setBetMax();
    }

    onPressCloseBetSettings() {
        this.hud.hideBetSettings();
    }

    onBetChanged(value) {
        this.hud.setBetValue(value);
    }

    onCoinValueChanged(value) {
        this.hud.setCoinValue(value);
    }

    /**
     * @param {string} type - SpinSpeedTypes constant (NORMAL/QUICK/TURBO)
     */
    onSpinSpeedChange(type) {
        const typeMap = {
            "NORMAL": "normal",
            "QUICK": "quick",
            "TURBO": "turbo"
        };
        this.data.spinType = typeMap[type] || "normal";
    }

    handlePressAutoplay() {
        this.gameState.goTo("AutoplaySettingsState");
    }

    onPressSettings() {
        this.gameState.goTo("SystemSettingsPopupState");
    }

    onPressBuyBonus() {
        this.gameState.goTo("BuyFreeSpinsState");
    }

    onPressInfo() {
        this.gameState.goTo(GameStates.InfoPageState);
    }

    exit() {
        super.exit();

        this.signals.disconnectAll();

        if (this.tl) {
            this.tl.kill();
            this.tl = null;
        }

        this.hud.setSpinningState();
    }

    spin() {
        if (services.gameLogic.canBet()) {
            this.gameState.goTo(GameStates.SPINNING);
        }
    }

    async handleToggleDoubleChance(value) {
        const options = await services.gameLogic.setDoubleChanceFeature(value);

        if (options.feature && options.feature.toggle) {
            this.hud.setDoubleChance(true);
        } else {
            this.hud.setDoubleChance(false);
        }

        this.gameState.setBetOptions(options);
    }
}
